import { tsUtils } from '@neo-one/ts-utils';
export const hasBooleanFalse = (_context, _node, type) => tsUtils.type_.hasBooleanFalse(type);
export const isBooleanFalse = (_context, _node, type) => tsUtils.type_.isBooleanFalse(type);
export const hasBoolean = (_context, _node, type) => tsUtils.type_.hasBooleanish(type);
export const isOnlyBoolean = (_context, _node, type) => tsUtils.type_.isOnlyBooleanish(type);
export const isBoolean = (_context, _node, type) => tsUtils.type_.isBooleanish(type);

//# sourceMappingURL=typeTests.js.map
